import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import {Button} from "primereact/button";
import ContextMenu from "../../../components/contextMenu";


const TodayTrade = ({
                        ...props
                    }) => {
    return (

        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>

                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Ventanilla \ Hechos \ Hechos del Día"/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'right'}}>
                        <Button label="Regresar" onClick={props.handleReturnButton}
                                className="p-button-secondary"
                                style={{visibility: 'hidden'}}/>
                        <Button label="Buscar"
                                onClick={props.getTodayTrade}/>
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.todayTrade}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="emisora" header="Instrumento"
                                    style={{textAlign: 'left', width: '30%'}} sortable={true}/>
                            <Column field="cantidad" header="Títulos"
                                    style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="plazo" header="Plazo Promedio"
                                    style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};
export default TodayTrade;
